import gql from "graphql-tag";

export const GET_ICON_ROYALTY_STATEMENTS = gql`
    query getIconRoyaltyStatements($username: String) {
        royaltyStatements(username: $username) {
            ok
            errors
            statements {
                totalIconEarnings
                earnings {
                    api {
                        iconEarnings
                    }
                    subscription {
                        iconEarnings
                        collectionIconEarnings
                    }
                    purchase {
                        iconEarnings
                    }
                }
                payout {
                    paypalEmail
                    earnings {
                        icon
                    }
                    createdAt
                    payoutDate
                    paypalEmail
                    totalPayout
                }
                paypalEmail
                createdAt
                royaltiesDate
                counts {
                    api {
                        iconCount
                    }
                    subscription {
                        iconCount
                        collectionIconCount
                    }
                    purchase {
                        iconCount
                    }
                    free {
                        iconCount
                    }
                }
            }
        }
    }
`;
